import React, { useEffect, useState } from 'react'
import ButtonBackComponent from '../../../../component/buttton/ButtonBack.component'
import { Title } from '../../../../component/title/Title';
import GridComponent from '../../../../component/grid/GridComponent.component';
import ButtonComponent from '../../../../component/buttton/Button.component';
import ExportExcel from './exportExcel/exportExcel.component';
import FormComponent from './components/form/FormFilter.component';
import Table, { TableDiv } from './Report.styles'
import { useSnackbar } from '../../../../context/Snackbar';
import { getReport } from './Report.service';
import { reportDTO } from './Interface/ReportDto';
import { useManagement } from '../../../../context/Management';
import Loader from '../../../../component/Loader/LoaderComponent';

const ReportComponent = () => {
  const { setSnackbar } = useSnackbar();
  const { valueCd } = useManagement();
  const [report, setReport] = useState<reportDTO[]>([]);
  const [reportFilter, setReportFilter] = useState<reportDTO[]>([]);
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(true);

  const getReports = async () => {
    if (valueCd) {
      try {
        const unique:any = []
        const newResult:any = []

        const result = await getReport(valueCd)
        const order = result.sort((a,b) => a.DataCriacao.localeCompare(b.DataCriacao))
        order.forEach((item) => {
          const isDuplicate = unique.includes(item.Transporte)
          if(!isDuplicate) {
            unique.push(item.Transporte)
            newResult.push(item)
          }
        })
        setReport(newResult);
        setReportFilter(newResult)
        setLoading(false);
      } catch(e) {
        setSnackbar({ type: 'error', msg: 'Erro na comunicação com API.', subMsg: '' })
        setLoading(false);
      }

    } else {
      setSnackbar({ type: 'error', msg: 'CD não selecionado.', subMsg: 'Por favor selecione um CD.' })
      setLoading(false)
    }

  }

  const handleFilter = async (data: any) => {
    try {
      setLoading(true);

      var initialDate = data.DataInicio.getFullYear() + "-" + ("0" + (data.DataInicio.getMonth() + 1)).slice(-2) + "-" + ("0" + data.DataInicio.getDate()).slice(-2)
      var finalDate = data.DataFim.getFullYear() + "-" + ("0" + (data.DataFim.getMonth() + 1)).slice(-2) + "-" + ("0" + data.DataFim.getDate()).slice(-2)

      try {
        const uniqueResult:any = []
        const newResult:any = []
        const result = await (await getReport(valueCd, initialDate, finalDate))
          .sort((a,b) => parseFloat(b.FimDescarregamentohora.replaceAll(":",'.')) - parseFloat(a.FimDescarregamentohora.replaceAll(":",'.')))
        result.forEach((item) => {
          const isDuplicate = uniqueResult.includes(item.Transporte)
          if(!isDuplicate) {
            uniqueResult.push(item.Transporte)
            newResult.push(item)
          }
        })

        if (data.Transporte || data.Destino) {
          let filterResult = [...newResult].filter((item) => {
            let includesTransp: boolean = data.Transporte !== '' ? item.Transporte.toLowerCase().includes(data.Transporte.toLowerCase()) :
              item.Transporte.toLowerCase().includes(item.Transporte.toLowerCase())
            let inclcudesDestiny: boolean = data.Destino !== '' ? item.Destino.toLowerCase().includes(data.Destino.toLowerCase()) :
              item.Destino.toLowerCase().includes(item.Destino.toLowerCase())

            return includesTransp && inclcudesDestiny

          })

          setReportFilter(filterResult)
        } else {
          setReportFilter(newResult.sort((a:any,b:any) => Number(new Date(b.DataCriacao)) - Number(new Date(a.DataCriacao))))
        }
        setLoading(false);
      } catch (e) {
        setSnackbar({ type: 'error', msg: 'Erro na comunicação com API.', subMsg: '' })
        setLoading(false);
      }

    } catch (e) {
      setSnackbar({ type: 'error', msg: 'Campos obrigatórios.', subMsg: 'Data inicio e Data fim são obrigatórios.' })
      setLoading(false);
    }

  }

  useEffect(() => {
    getReports()
  }, [])

  return (
    <>
      <ButtonBackComponent to="/gestao-de-patio" />
      <Title fontSize={30} fontWeigth='900' margin="0px 0px 20px 0px">Relatório</Title>
      {loading ? <Loader /> : (
        <>
          <GridComponent justify="flex-end" alignItems="center" margin='0px 0px 10px 0px'>
            <ButtonComponent onClick={() => setShowFilter(!showFilter)} title='filtro' size='medium' margin='16px 0px 0px 0px' />
          </GridComponent>
          {
            showFilter && <FormComponent handleSubmitForm={handleFilter} />
          }
          <ExportExcel />
          <TableDiv id='tableData'>
            <Table>
              <Table.Trow>
                <Table.TheadCell></Table.TheadCell>
                <Table.TheadCell></Table.TheadCell>
                <Table.TheadCell></Table.TheadCell>
                <Table.TheadCell></Table.TheadCell>
                <Table.TheadCell></Table.TheadCell>
                <Table.TheadCell></Table.TheadCell>
                <Table.TheadCell colSpan={3}>Quantidade Paletes</Table.TheadCell>
                <Table.TheadCell colSpan={2}>Entrada Patio</Table.TheadCell>
                <Table.TheadCell colSpan={2}>Entrada Doca</Table.TheadCell>
                <Table.TheadCell colSpan={2}>Transito Destino</Table.TheadCell>
                <Table.TheadCell colSpan={2}>Inicio Descarregamento</Table.TheadCell>
                <Table.TheadCell colSpan={2}>Fim Descarregamento</Table.TheadCell>
              </Table.Trow>
              <Table.Trow>
                <Table.TheadCell>Data</Table.TheadCell>
                <Table.TheadCell>Transporte</Table.TheadCell>
                <Table.TheadCell>Destino</Table.TheadCell>
                <Table.TheadCell>Origem</Table.TheadCell>
                <Table.TheadCell>Veiculo</Table.TheadCell>
                <Table.TheadCell>Doca</Table.TheadCell>
                <Table.TheadCell>Estimada</Table.TheadCell>
                <Table.TheadCell>Separada</Table.TheadCell>
                <Table.TheadCell>Expedida</Table.TheadCell>
                <Table.TheadCell>Data</Table.TheadCell>
                <Table.TheadCell>Hora</Table.TheadCell>
                <Table.TheadCell>Data</Table.TheadCell>
                <Table.TheadCell>Hora</Table.TheadCell>
                <Table.TheadCell>Data</Table.TheadCell>
                <Table.TheadCell>Hora</Table.TheadCell>
                <Table.TheadCell>Data</Table.TheadCell>
                <Table.TheadCell>Hora</Table.TheadCell>
                <Table.TheadCell>Data</Table.TheadCell>
                <Table.TheadCell>Hora</Table.TheadCell>
              </Table.Trow>
              {reportFilter.map((report, index) => (
                <Table.Trow key={index}>
                  <Table.TrowCell>{report.DataCriacao}</Table.TrowCell>
                  <Table.TrowCell>{report.Transporte}</Table.TrowCell>
                  <Table.TrowCell>{report.Destino}</Table.TrowCell>
                  <Table.TrowCell>{report.Origem}</Table.TrowCell>
                  <Table.TrowCell>{report.Veiculo}</Table.TrowCell>
                  <Table.TrowCell>{report.Doca}</Table.TrowCell>
                  <Table.TrowCell>{report.Estimada}</Table.TrowCell>
                  <Table.TrowCell>{report.Separado}</Table.TrowCell>
                  <Table.TrowCell>{report.Expedido}</Table.TrowCell>
                  <Table.TrowCell>{report.HoraEntradaPatio ? report.DataEntradaPatio : null}</Table.TrowCell>
                  <Table.TrowCell>{report.HoraEntradaPatio}</Table.TrowCell>
                  <Table.TrowCell>{report.DataEntradaDoca ? report.DataEntradaDoca : null}</Table.TrowCell>
                  <Table.TrowCell>{report.HoraentradaDoca}</Table.TrowCell>
                  <Table.TrowCell>{report.TransitoDestinoHora ? report.TransitoDestinoData : null}</Table.TrowCell>
                  <Table.TrowCell>{report.TransitoDestinoHora}</Table.TrowCell>
                  <Table.TrowCell>{report.InicioDescarregamentohora ? report.InicioDescarregamentoData : null}</Table.TrowCell>
                  <Table.TrowCell>{report.InicioDescarregamentohora}</Table.TrowCell>
                  <Table.TrowCell>{report.FimDescarregamentohora ? report.FimDescarregamentoData : null}</Table.TrowCell>
                  <Table.TrowCell>{report.FimDescarregamentohora}</Table.TrowCell>
                </Table.Trow>
              ))}

            </Table>
          </TableDiv>
        </>
      )}

    </>
  )
}

export default ReportComponent
